export const playRingtone = async (ringtoneEl, setError, playError) => {
  try {
    await ringtoneEl.play();
    if (playError) {
      setError(null);
    }
  } catch (err) {
    if (!playError) {
      setError(err);
      console.log('play ringtone err', err);
    }
  }
};

export const stopRingtone = (ringtoneEl) => {
  if (!ringtoneEl.paused) {
    ringtoneEl.pause();
    ringtoneEl.currentTime = 0;
  }
};
